<template>
  <b-container fluid>
    <b-row class="justify-content-center" v-if="!loaded && loading">
      <b-spinner big label="Loading..."></b-spinner>
    </b-row>

    <b-row>
      <b-container fluid>
        <b-row style="margin-bottom:15px;">
          <b-col style="padding: 0px;" class="m-2 bordered-box-header">
            <p class="m-2 text-left">
              Liczba wszystkich poznanych słówek i wyrażeń:
              <b>{{allKnownWords}}</b>
            </p>
            <p class="m-2 text-left">
              Liczba przećwiczonych słówek i wyrażeń:
              <b>{{allTrainedWords}}</b>
            </p>
          </b-col>
        </b-row>
        <b-row>
          <b-col style="padding: 0px;">
            <filters-panel class="ml-3" @filters-search="onSearch"></filters-panel>
          </b-col>
        </b-row>
        <b-row>
          <b-col style="padding: 0px;">
            <data-table
              class="m-2"
              ref="table"
              :dtFields="fields"
              :dtFieldsKey="primaryKey"
              :dtPageSizes="pageSizes"
              :dtPageSize="pageSize"
              :dtPage="currentPage"
              :dtItemsProvider="getData"
              :dtItemsTotal="total"
              @onInfo="onInfo"
            ></data-table>
          </b-col>
        </b-row>
      </b-container>
    </b-row>

    <b-modal v-model="showInfoModal" size="xl" ok-only>
      <template slot="modal-title">Szczegóły</template>
      <b-container>
        <b-row>
          <b-col>
            <h2>{{this.selectedItem != null ? this.selectedItem.term : ""}} ({{this.selectedItem != null ? this.selectedItem.translation : ""}})</h2>
          </b-col>
        </b-row>
        <b-row>
          <b-col style="padding: 0px;">
            <data-table
              class="m-2"
              ref="detailsTable"
              :dtFields="detailsFields"
              :dtFieldsKey="primaryKey"
              :dtPageSizes="detailsPageSizes"
              :dtPageSize="detailsPageSize"
              :dtPage="detailsCurrentPage"
              :dtItemsProvider="getDetails"
              :dtItemsTotal="detailsTotal"             
            ></data-table>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </b-container>
</template>

<script>
import { axios, eventBus } from "@/_infrastructure";
// import { required } from "vuelidate/lib/validators";
// import { debuglog } from "util";
import moment from "moment";
import DataTable from "@/components/DataTable.vue";
import FiltersPanel from "./DetailsStatisticsFiltersPanel.vue";

const fields = [
  { key: "index", sortable: false, label: "#" },
  { key: "term", sortable: true, label: "Wyrażenie" },
  { key: "translation", sortable: true, label: "Tłumaczenie" },
  { key: "correct", sortable: true, label: "Poprawnie" },
  { key: "incorrect", sortable: true, label: "Błędnie" },
  { key: "lastAnswerDate", sortable:true, label:"Data ostatniej odpowiedzi"},
  { key: "info", sortable: false, label: "", tdClass: "b-table-action" }
];

const detailsFields = [
  { key: "index", sortable: false, label: "#" },
  { key: "correctAnswer", sortable: true, label: "Oczekiwana odpowiedź" },
  { key: "answer", sortable: true, label: "Odpowiedź" },
  { key: "type", sortable: true, label: "Ćwiczenie" },
  { key: "correct", sortable: true, label: "Poprawna" },
  { key: "answerDate", sortable: true, label: "Data" }
];

const primaryKey = "id";

export default {
  components: { DataTable, FiltersPanel },
  data() {
    return {
      isLoading: true,
      loading: false,
      loaded: false,
      showInfoModal: false,
      filters: null,
      primaryKey: primaryKey,
      items: null,
      selectedItem: null,
      pageSizes: [10, 20, 50, 100],
      pageSize: 20,
      currentPage: 1,
      total: 0,
      fields: fields,
      detailsPageSizes: [10, 20, 50, 100],
      detailsPageSize: 10,
      detailsCurrentPage: 1,
      detailsTotal: 0,
      detailsFields: detailsFields,
      allKnownWords: 0,
      allTrainedWords: 0
    };
  },
  mounted() {
    if (this.id) {
      axios
        .get("/students/answers/statistics", {
          params: {
            id: this.id
          }
        })
        .then(response => {
          let result = response.data;

          this.allKnownWords = result.allKnownWords;
          this.allTrainedWords = result.allTrainedWords;
        })
        .catch(error => eventBus.$emit("unhandled-error", error));
    } else {
      eventBus.$emit("unhandled-error", "Wystąpił błąd");
    }
  },
  props: ["id"],
  methods: {
    goto(url) {
      this.$router.push(url);
    },
    // eslint-disable-next-line 
    onInfo(rowId) {
      this.selectedItem = this.items.filter(function(item) {
        return item.id == rowId;
      })[0];

      this.showInfoModal = true;
    },
    onSearch(filters) {
      this.filters = filters;
      this.$refs.table.refresh();
    },
    getData(ctx) {
      var self = this;
      var queryObject = { ...ctx, ...this.filters };
      queryObject.userId = this.id;

      return axios
        .get("students/answers", { params: queryObject })
        .then(result => {
          self.total = result.data.total;
          this.items = result.data.rows;
          this.items.forEach(function(item) {
            item.id = item.wordId;

            if (item.lastAnswerDate){
            item.lastAnswerDate = moment(item.lastAnswerDate).format(
                "YYYY-MM-DD HH:mm"
              );
            }
          });

          return this.items;
        })
        .catch(err => {
          eventBus.$emit("unhandled-error", err);
          return null;
        });
    },
    getDetails(ctx) {
      if (this.showInfoModal) {
        var self = this;
        var queryObject = { ...ctx, ...this.filters };
        
        queryObject.userId = this.id;
        queryObject.wordId = this.selectedItem.id;
        
        return axios
          .get("students/answers/details", { params: queryObject })
          .then(result => {
            self.detailsTotal = result.data.total;

            let resultData = result.data.rows;

            resultData.forEach(function(item) {
              item.answerDate = moment(item.answerDate).format(
                "YYYY-MM-DD HH:mm"
              );
              item.correct = item.correct ? "tak" : "nie";

              switch (item.type) {
                case 0:
                  item.type = "Wypełnij lukę";
                  break;
                case 1:
                  item.type = "Przetłumacz";
                  break;
                case 2:
                  item.type = "Połącz w pary";
                  break;
              }
            });

            return resultData;
          })
          .catch(err => {
            eventBus.$emit("unhandled-error", err);
            return null;
          });
      }
    }
  },
  watch: {  
    showInfoModal: function(newValue) {
      if (newValue) {
        this.$refs.detailsTable.refresh();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
